var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.paperDetailLoading,
          expression: "paperDetailLoading",
        },
      ],
      staticClass: "paper-container",
    },
    [
      _c(
        "div",
        { staticClass: "paper-detail" },
        [
          _c(
            "div",
            { staticClass: "paper-title flex items-center" },
            [
              _c("span", { staticClass: "paper-bg" }, [_vm._v("论文")]),
              _vm.paperData.url
                ? _c(
                    "span",
                    {
                      staticClass: "paper-title-style",
                      staticStyle: { cursor: "pointer" },
                      on: { click: _vm.clickPDFView },
                    },
                    [_vm._v(_vm._s(_vm.paperData.title))]
                  )
                : _c("span", { staticClass: "paper-title-style" }, [
                    _vm._v(_vm._s(_vm.paperData.title)),
                  ]),
              _vm._l(
                _vm.paperData.jcrPartitionList,
                function (jcrItem, jcrIndex) {
                  return _c("div", { key: jcrIndex }, [
                    jcrItem
                      ? _c(
                          "div",
                          {
                            staticClass: "jcr-view ellipsis",
                            attrs: { title: jcrItem },
                          },
                          [_vm._v(" " + _vm._s(jcrItem) + " ")]
                        )
                      : _vm._e(),
                  ])
                }
              ),
            ],
            2
          ),
          _c("div", {
            staticStyle: {
              width: "100%",
              "border-bottom": "1px dashed #e8eaee",
              "margin-top": "20px",
              "margin-bottom": "6px",
            },
          }),
          _c(
            "collapse",
            { attrs: { "default-height": 37, "hide-control": false } },
            [
              _c(
                "div",
                { staticClass: "flex items-center flex-wrap" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "textSpan noWrap",
                      staticStyle: { "margin-top": "14px" },
                    },
                    [_vm._v("作者：")]
                  ),
                  (_vm.paperData.authorList == null ||
                    _vm.paperData.authorList.length == 0) &&
                  (_vm.paperData.authors == null ||
                    _vm.paperData.authors.length == 0)
                    ? _c("div", [_vm._v(" - ")])
                    : _vm._e(),
                  _vm._l(
                    _vm.paperData.authorList || _vm.paperData.authors,
                    function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "flex items-center",
                          staticStyle: {
                            "margin-right": "11px",
                            cursor: "pointer",
                            "margin-top": "14px",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.goPersonalDetails(
                                item.id || item.scholarId
                              )
                            },
                          },
                        },
                        [
                          _c("el-avatar", {
                            staticClass: "avatar",
                            attrs: { size: 18, src: item.avatarUrl },
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "textContent noWrap",
                              staticStyle: { "margin-left": "6px" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(item.name || item.scholarName) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }
                  ),
                ],
                2
              ),
            ]
          ),
          _vm.paperData.venue !== null
            ? _c("div", { staticClass: "text-title" }, [
                _c("span", { staticClass: "textSpan" }, [_vm._v("出版物：")]),
                _c("div", { staticClass: "textContent" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.paperData.venue == null ? "-" : _vm.paperData.venue
                      ) +
                      " "
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "text-title" }, [
            _c("span", { staticClass: "textSpan" }, [
              _vm._v("期刊影响因子(JCR)："),
            ]),
            _c("div", { staticClass: "textContent" }, [
              _vm._v(_vm._s(_vm.paperData.impactFactor)),
            ]),
          ]),
          _vm.paperData.jcrArea
            ? _c("div", { staticClass: "text-title" }, [
                _c("span", { staticClass: "textSpan" }, [_vm._v("JCR分区：")]),
                _c("div", { staticClass: "textContent" }, [
                  _vm._v(_vm._s(_vm.paperData.jcrArea || "-")),
                ]),
              ])
            : _vm._e(),
          _vm.paperData.volume
            ? _c("div", { staticClass: "text-title" }, [
                _c("span", { staticClass: "textSpan" }, [_vm._v("卷号：")]),
                _c("div", { staticClass: "textContent" }, [
                  _vm._v(" " + _vm._s(_vm.paperData.volume || "-") + " "),
                ]),
              ])
            : _vm._e(),
          _vm.paperData.year
            ? _c("div", { staticClass: "text-title" }, [
                _c("span", { staticClass: "textSpan" }, [_vm._v("发表时间：")]),
                _c("div", { staticClass: "textContent" }, [
                  _vm._v(_vm._s(_vm.paperData.year || "-")),
                ]),
              ])
            : _vm._e(),
          _vm.paperData.citationNum !== null
            ? _c("div", { staticClass: "text-title" }, [
                _c("span", { staticClass: "textSpan" }, [_vm._v("引用次数：")]),
                _c("div", { staticClass: "textContent" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.paperData.citationNum == null
                          ? "-"
                          : _vm.paperData.citationNum
                      ) +
                      " "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.paperData.keywords != null && _vm.paperData.keywords.length != 0
            ? _c("div", { staticClass: "text-title" }, [
                _c("span", { staticClass: "textSpan" }, [_vm._v("关键词：")]),
                _c(
                  "div",
                  { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
                  [
                    _vm.paperData.keywords == null ||
                    _vm.paperData.keywords.length == 0
                      ? _c("div", [_vm._v(" - ")])
                      : _vm._e(),
                    _vm._l(_vm.paperData.keywords, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticStyle: { color: "#2e1f88" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                item !== "" && item !== "[]" ? item + "；" : ""
                              ) +
                              " "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "text-title" }, [
            _c("span", { staticClass: "textSpan" }, [
              _vm._v("摘要："),
              _c("span", { staticClass: "textContent abstract" }, [
                _vm._v(_vm._s(_vm.paperData.abst ? _vm.paperData.abst : "-")),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }